import Transform from '@ember-data/serializer/transform';
import DecimalStockCount from '@square/dashboard-items-data/models/decimal-stock-count';

// eslint-disable-next-line ember/no-classic-classes
export default Transform.extend({
  deserialize(serialized) {
    return DecimalStockCount.deserialize(serialized);
  },
  serialize(deserialized) {
    return DecimalStockCount.serialize(deserialized);
  }
});